import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

// export const GetSubCategory = createAsyncThunk(
//   "subCategory/GetSubCategory",
//   async (name, thunkAPI) => {
//     try {
//       const response = await axios.get(`${endPoint.GETSUBCATEGORY}/${encodeURIComponent(name)}`);
//       console.log("response.data", response.data)
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

export const GetSubCategory = createAsyncThunk(
  "subCategory/GetSubCategory",
  async ({ name, page, limit = 50 }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.GETSUBCATEGORY}/${encodeURIComponent(name)}?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);


const GetSubCategorySlice = createSlice({
  name: "AllSubCategory",
  initialState: {
    AllSubCategory: [],
    currentPage: 1,
    totalPages: 0,
    error: null,
  },
  reducers: {
    clearAllSubCategory: (state) => {
      state.AllSubCategory = [];
      state.error = null;
      state.totalPages = 0;
      state.currentPage = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetSubCategory.fulfilled, (state, action) => {
        state.AllSubCategory = action.payload || []; // depends on API
        state.totalPages = action.payload?.totalPages || 0;
        state.currentPage = action.payload?.currentPage || 1;
      })
      .addCase(GetSubCategory.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});


// const GetSubCategorySlice = createSlice({
//   name: "AllSubCategory",
//   initialState: {
//     AllSubCategory: [],
//     error: null,
//   },
//   reducers: {
//     clearAllSubCategory: (state) => {
//       state.AllSubCategory = [];
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(GetSubCategory.fulfilled, (state, action) => {
//         state.AllSubCategory = action.payload;
//       })
//       .addCase(GetSubCategory.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });

export const { clearAllSubCategory } = GetSubCategorySlice.actions;
export default GetSubCategorySlice.reducer;
